import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'event-listing',
  templateUrl: './event-listing.component.html',
  styleUrls: ['./event-listing.component.css']
})
export class EventListingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/home/event-listing/event-listing.component.ts